import { LandingTranslationType } from "../../features/landing.types";

export const landing: LandingTranslationType = {
  landing: {
    hero: {
      title: "Ustvarite svojo zgodbo z UI",
      subtitle: "Kjer se domišljija sreča z umetno inteligenco",
      description: "Uporabljajte našo interaktivno pripovedovalno platformo z umetno inteligenco za ustvarjanje privlačnih zgodb in likov",
      startStory: "Začnite svojo zgodbo",
      signIn: "Prijava"
    },
    features: {
      title: "Sprostite svojo ustvarjalnost",
      aiPowered: {
        title: "Zgodbe z UI",
        description: "Ustvarite edinstvene pripovedi z našim naprednim UI pripovednim motorjem"
      },
      interactiveChoices: {
        title: "Interaktivne izbire",
        description: "Oblikujte svojo zgodbo skozi pomembne odločitve in prilagojene akcije"
      },
      creativeFreedom: {
        title: "Ustvarjalna svoboda",
        description: "Zapišite svojo pot z neomejenimi ustvarjalnimi možnostmi"
      }
    },
    preview: {
      title: "Predogled zgodbe",
      storyText: "Starodavna vrata so zaškripala in odkrila sobo, kopano v eterični modri svetlobi. Iz sten so štrlele kristalne formacije, njihove površine so odsevale nešteto majhnih mavric po sobi. Na sredini, lebdeč nekaj centimetrov nad podstavkom iz črnega marmorja, je bila knjiga, vezana v nekaj, kar je bilo videto kot zvezdna svetloba...",
      whatToDo: "Kaj storite?",
      choice1: "Previdno se približajte knjigi in preiščite sobo za pastmi",
      choice2: "Uporabite svojo magijo za zaznavanje nevarnih urokov",
      choice3: "Pogumno zgrabite knjigo - sreča je na strani pogumnih!"
    },
    callToAction: {
      title: "Ste pripravljeni začeti svoje potovanje?",
      subtitle: "Pridružite se tisočim pripovedovalcem, ki ustvarjajo edinstvene pustolovščine z UI",
      button: "Začnite pisati zdaj"
    },
    storyPreview: {
      header: "Doživite poglobljeno pripovedovanje zgodb",
      description: "Ustvarjajte, raziskujte in oblikujte zgodbe v dinamičnem interaktivnem okolju z {{appName}}",
      genres: "Žanri",
      themes: "Teme",
      environment: "Okolje",
      writeResponse: "Napišite svoj odgovor...",
      previousStory: "Prejšnja zgodba",
      nextStory: "Naslednja zgodba",
      goToStory: "Pojdi na zgodbo {{number}}"
    },
    creativeSuite: {
      title: "Kreativni paket",
      description: "Zmogljiva orodja za odklepanje vašega pripovednega potenciala in oživljanje vaše domišljije",
      categories: {
        stories: "Zgodbe",
        characters: "Liki",
        premium: "Premium"
      },
      premiumFeature: "Premium funkcija",
      basicFeature: "Na voljo v osnovnem paketu",
      freeFeature: "Brezplačno za vse",
      getStarted: "Začnite",
      noCreditCard: "Za začetek ustvarjalne poti ne potrebujete kreditne kartice",
      tools: {
        aiWriting: {
          title: "Pisanje z UI",
          description: "Ustvarjajte zgodbe izberi-svojo-pustolovino z napredno umetno inteligenco. Napredujte s predlaganimi odzivi ali napišite svoje."
        },
        genresThemes: {
          title: "Obsežni žanri, teme in okolja",
          description: "Kot brezplačen uporabnik dostopajte do omejenega nabora žanrov ali odklenite vse žanre in teme z osnovnim paketom."
        },
        sequels: {
          title: "Nadaljevanja zgodb in serije",
          description: "Nadaljujte svoje najboljše zgodbe z nadaljevanji in ustvarite zanimive serije zgodb."
        },
        characterBuilder: {
          title: "Graditelj likov",
          description: "Oblikujte zapletene like z natančnimi osebnostmi, motivacijami in ozadji."
        },
        aiPortraits: {
          title: "UI portreti likov",
          description: "Ustvarite edinstvene vizualne predstavitve svojih likov z našim generatorjem portretov UI."
        },
        characterExtract: {
          title: "Ekstrakcija likov",
          description: "Samodejno izvlecite like iz svojih zgodb za gradnjo knjižnice likov."
        },
        sharing: {
          title: "Deljenje in objavljanje zgodb",
          description: "Delite svoje zgodbe in jih objavite, da jih bodo drugi lahko uživali in cenili."
        },
        unlimitedStorage: {
          title: "Povečana omejitev zgodb",
          description: "Ustvarite do 5 zgodb na dan z brezplačno različico, 25 z osnovno ali neomejeno število zgodb s premium različico."
        },
        statsBadges: {
          title: "Statistika in značke",
          description: "Spremljajte svoje pisalne statistike in prislužite si značke za svoje pripovedne dosežke."
        }
      }
    },
    exampleStories: {
      dragonsRiddle: {
        title: "Zmajeva uganka",
        excerpt: "Starodavni zmaj je zastavil uganko, ki je ostala nerešena stoletja. \"Odgovori pravilno,\" je zarenčal, \"in ti dovolim prehod skozi goro.\" Luske ogromne pošasti so se lesketale kot obsidian v medli svetlobi jame. Stal sem tam, s konicami prstov, trepetajočimi ob hladnem kamnu, moji tovariši za menoj so okamneli. Zmajeve jantarne oči so se uprle v moje. \"Toda če ne uspeš,\" je nadaljevala zver, \"se boš pridružil kostem tistih, ki so prišli pred teboj.\" Pokazal je na raztresene ostanke, ki sem jih poskušal ne opaziti. Zmaji so bili naklonjeni besednim igram in skritim pomenom. Usoda naše misije je bila odvisna od moje sposobnosti dešifriranja uganke pošasti.",
        suggestion1: "\"Odgovor je 'čas' - požira vse, a sam ni nikoli požrt,\" sem razglasil z več samozavesti, kot sem je čutil.",
        suggestion2: "Spoštljivo sem se priklonil starodavni zveri. \"Veliki, ali smem postaviti pojasnjevalno vprašanje o vaši uganki?\"",
        suggestion3: "Pogledal sem prestrašene obraze svojih tovarišev, preden sem se obrnil nazaj k zmaju. \"Morda bi lahko izpogajali drugo pot skozi?\""
      },
      echoesFromTomorrow: {
        title: "Odmevi iz jutri",
        excerpt: "Dr. Miranda Chen je strmela v sporočilo na svojem zaslonu. Prispelo je včeraj, vendar je časovni žig kazal, da je bilo poslano jutri. Ponovno je prebrala: \"Protokol Omega sprožen. NE nadaljujte z testnim zaporedjem. Neposredno preti katastrofalni časovni kolaps.\" Miranda je preverila kvantno komunikacijsko polje, ki ga je oblikovala - namenjeno je bilo zmanjšanju latence signala, ne prebijanju tančice med zdaj in jutri. Kvantni podpisi, vdelani v sporočilo, so se natančno ujemali z njihovimi protokoli šifriranja, z eno nemogočo anomalijo: kazali so vzorce razpada, ki še ne bi smeli obstajati. Ko je njen terminal zazvonil z drugim prihajajočim sporočilom, je Miranda začutila srh. ID pošiljatelja je prikazoval njeno lastno ime.",
        suggestion1: "Miranda je hitro natipkala: \"To je dr. Chen. Identificirajte se in pojasnite, kako dostopate do naših varnih sistemov.\"",
        suggestion2: "Sprožila je zasilno zaustavitev, medtem ko je varnostno kopirala vse podatke projekta na varen zunanji strežnik.",
        suggestion3: "Poklicala je svojega raziskovalnega partnerja: \"Kenji, nekaj nemogočega se dogaja s kvantnim poljem.\""
      },
      forgottenLibrary: {
        title: "Pozabljena knjižnica",
        excerpt: "Knjižnica se je pojavljala samo v deževnih nočeh, njena vrata so se odpirala tistim, ki so najbolj potrebovali odgovore. Iskal sem jo leta, sledil govoricam in nejasnim referencam. Zdaj, ko sem stal pred njeno nemogočo arhitekturo - večjo znotraj kot zunaj - sem okleval. Ogromna hrastova vrata so bila nekoliko priprta, topla svetloba se je razlivala na mokre tlakovce. Vhodna dvorana se je dvigala neverjetno visoko, police so segale onkraj tam, kjer bi moral biti strop. Zrak je dišal po papirju, črnilu in nečem starejšem - kot bi sam čas imel vonj. Opazil sem, da so šepeti postajali močnejši, prihajali so iz tisoč knjig, ki so vse govorile naenkrat. Potem se je en glas dvignil nad druge: \"Čakali smo te.\"",
        suggestion1: "\"Kdo je tam?\" sem zaklical, moj glas je odmeval skozi prostrani prostor, medtem ko sem preiskoval senčne hodnike.",
        suggestion2: "Približal sem se najbližji polici in z roko drsel po starodavnih hrbtiščih, sprašujoč se, katera knjiga je spregovorila.",
        suggestion3: "\"Prišel sem iskat informacije o Nebesni konvergenci,\" sem naznanil šepetajoči knjižnici."
      }
    }
  }
};